import React from "react";

const BADGES = [
  { key: "bronze", label: "Bronze" },
  { key: "silver", label: "Silver" },
  { key: "gold", label: "Gold" },
  { key: "diamond", label: "Diamond" },
  { key: "platinum", label: "Platinum" },
];

function DashboardBadgesSection({ earnedBadges = {} }) {
  const totalBadgesEarned = BADGES.reduce((sum, b) => {
  return sum + (earnedBadges[b.key]?.count || 0);
}, 0);


  return (
    <div className="dashboard-badges-wrap">
      <div className="dashboard-badges-row row1">
        <h3 className="h3-head">Earned Badges</h3>
        <p>
          <p>{totalBadgesEarned} earned</p>
        </p>
      </div>

      <div className="dashboard-badges-row row2" data-aos="fade-right">
        {BADGES.map((badge) => {
          const badgeData = earnedBadges[badge.key] || {
            earned: false,
            count: 0,
          };

          return (
            <div
              key={badge.key}
              className={`dashboard-badges-box ${
                !badgeData.earned ? "locked" : ""
              }`}
            >
              <div className="dashboard-badges-holder">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    (badgeData.earned
                      ? "/Assets/Dashboard/badges-icon.png"
                      : "/Assets/Dashboard/badges-lock-key.png")
                  }
                  alt={badge.label}
                  className="badges-all-icon"
                />
              </div>

              <p>
                {badgeData.earned && badgeData.count > 0
                  ? `${badgeData.count} ${badge.label}`
                  : badge.label}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DashboardBadgesSection;
